// Hero.js
import "./Hero.css";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import icon1 from "../../../assets/img/icon-1.png";
import icon2 from "../../../assets/img/icons-02.png";
import icon3 from "../../../assets/img/icons-03.png";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-top">
        <Zoom>
          <div className="welcome-note">
            <div>
              <h1>
                Sending positive <span className="span-1">Vibes</span> as we
                listen to you <span className="span-2">Vent</span> out your
                heart, mind, and soul.
              </h1>
            </div>
            <Link to={"/therapists"} className="find-a-therapist">
              Find a therapist
            </Link>
          </div>
        </Zoom>
      </div>
      <div className="hero-footer">
        <Fade left>
          <div className="hero-card" style={{ backgroundColor: "#00b5afbf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon2} alt="Affordable" />
              </div>
              <h3>Affordable</h3>
            </div>
            <p style={{ color: "#fff", marginTop: 20 }}>
              We believe mental health care should be accessible to everyone,
              which is why we prioritize affordability without compromising
              quality.
            </p>
          </div>
        </Fade>
        <Zoom>
          <div className="hero-card" style={{ backgroundColor: "#071c2dbf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon3} alt="Convenient" />
              </div>
              <h3>Convenient</h3>
            </div>
            <p style={{ color: "#fff", marginTop: 20 }}>
              Recognizing the demands of modern living, we provide flexible
              virtual appointments that fit seamlessly into your schedule.
            </p>
          </div>
        </Zoom>
        <Fade right>
          <div className="hero-card" style={{ backgroundColor: "#f37b20bf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon1} alt="You - Centered" />
              </div>
              <h3>You - Centered</h3>
            </div>
            <p style={{ color: "#fff", marginTop: 20 }}>
              Our approach revolves around you and your unique journey towards
              your mental wellness.
            </p>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default Hero;
